import { useEffect } from 'react';
import { useCartStore } from '@/stores/cartStore';

export function useCartSync(enabled = true) {
  const syncCart = useCartStore(state => state.syncCart);

  useEffect(() => {
    if (!enabled) return;
    syncCart();
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') syncCart();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [enabled, syncCart]);
}
